import 'bootstrap/dist/css/bootstrap.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './global.css';
import './styles/theme-det.css';
import './app/qr-reservation/qr-reservation.css';
import './i18n';

import { createRoot } from 'react-dom/client';
import DisplayPage from './app/displayPage';
import { Providers } from './provider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ThemeProvider } from '@material-tailwind/react';
import ToastContainerHome from './components/toast';

// Global error handler for uncaught promise rejections
window.addEventListener('unhandledrejection', (event) => {
	// Check if it's the specific ML API error
	if (
		event.reason &&
		typeof event.reason.message === 'string' &&
		event.reason.message.includes(
			"Unable to set camera info, cpp API hasn't been initialized"
		)
	) {
		event.preventDefault(); // Prevent the default error handling

		Swal.fire({
			title: 'Error',
			text: 'Some error occurred, try again',
			icon: 'error',
			confirmButtonText: 'OK',
		});
		return;
	}

	console.error('Unhandled promise rejection:', event.reason);
});

// Global error handler for uncaught errors
window.addEventListener('error', (event) => {
	// Check if it's the specific ML API error
	if (
		event.error &&
		typeof event.error.message === 'string' &&
		event.error.message.includes(
			"Unable to set camera info, cpp API hasn't been initialized"
		)
	) {
		event.preventDefault(); // Prevent the default error handling

		Swal.fire({
			title: 'Error',
			text: 'Some error occurred, try again',
			icon: 'error',
			confirmButtonText: 'OK',
		});
		return;
	}

	console.error('Uncaught error:', event.error);
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
// eslint-disable-next-line @typescript-eslint/no-var-requires
const $ = require('jquery');
const container = document.getElementById('root')!;
const root = createRoot(container);

import { ErrorBoundary } from 'react-error-boundary';

// 1. Create a Fallback component
const ErrorFallback = ({
	error,
	resetErrorBoundary,
}: {
	error: any;
	resetErrorBoundary: () => void;
}) => {
	// This runs when a component crashes
	React.useEffect(() => {
		Swal.fire({
			title: 'Error',
			text: 'Some error occurred, try again',
			icon: 'error',
			confirmButtonText: 'Reload Page',
		}).then(() => {
			resetErrorBoundary(); // This can trigger a re-render or redirect
			window.location.reload();
		});
	}, [error, resetErrorBoundary]);

	// Return a minimal UI so the screen isn't totally blank while Swal is open
	return (
		<div style={{ textAlign: 'center', marginTop: '50px' }}>
			Something went wrong.
		</div>
	);
};

root.render(
	<ThemeProvider>
		<ErrorBoundary FallbackComponent={ErrorFallback}>
			<Router>
				<Providers>
					<ToastContainerHome />
					<DisplayPage />
				</Providers>
			</Router>
		</ErrorBoundary>
	</ThemeProvider>
);
